import dayjs from 'dayjs'

/**
 * Formats a timeframe from hours.
 * @param timeStart the start time in hours
 * @param timeEnd the end time in hours
 */
export const formatTimeframeFromHours = ({
  timeEnd,
  timeStart,
}: {
  timeStart?: number
  timeEnd?: number
}) => {
  let formattedStartTime: string | undefined
  let formattedEndTime: string | undefined

  if (timeStart) {
    formattedStartTime = dayjs().hour(timeStart).format('ha')
  }

  if (timeEnd) {
    formattedEndTime = dayjs().hour(timeEnd).format('ha')
  }

  if (formattedStartTime && formattedEndTime) {
    return `${formattedStartTime} - ${formattedEndTime}`
  }

  if (formattedStartTime) {
    return `From ${formattedStartTime}`
  }

  if (formattedEndTime) {
    return `Until ${formattedEndTime}`
  }

  return ''
}

/**
 Formats a timeframe from a start and end timestamp.
 @param timeStart the start time as a timestamp string
 @param timeEnd the end time as a timestamp string
 */
export const formatTimeframeFromTimestamp = ({
  timeEnd,
  timeStart,
}: {
  timeStart?: string
  timeEnd?: string
}) => {
  let formattedStartTime: string | undefined
  let formattedEndTime: string | undefined

  if (timeStart) {
    formattedStartTime = dayjs(timeStart).format('MM/DD/YY h:mm a')
  }
  if (timeEnd) {
    formattedEndTime = dayjs(timeEnd).format('MM/DD/YY h:mm a')
  }

  if (formattedStartTime && formattedEndTime) {
    return `${formattedStartTime} - ${formattedEndTime}`
  }

  if (formattedStartTime) {
    return `From ${formattedStartTime}`
  }

  if (formattedEndTime) {
    return `Until ${formattedStartTime}`
  }

  return ''
}
